class Notification {
    constructor(id, headings, contents, url, send_after, dateUpdated, global_image, ios_attachments, status) {
        this.id = id
        this.headings = headings
        this.contents = contents
        this.url = url
        this.send_after = send_after
        this.dateUpdated = dateUpdated
        this.global_image = global_image
        this.status = status
        this.ios_attachments = ios_attachments
    }

    static from(json) {
        return Object.assign(new Notification(), json);
    }
}

export default Notification